import ko from 'knockout';

ko.extenders.locked = (target, options) => {
	target.locked = ko.observable(options);
};
